import { type CS_Customer, type CS_Invoice, type CS_PaymentIntent, type CS_Subscription, CS_castCustomer, CS_castInvoice, CS_castPaymentIntent, CS_castSubscription, type Stripe_CustomerID, type Stripe_PaymentIntentWithLatestCharge } from '@imago/api-client-stripe'
import { type UserID } from './documents/_EMR.ts';
import { type ProductID } from './documents/ServiceProduct.ts';

interface IS_CustomerMetadata {
	userID: UserID
	replacedWith: Stripe_CustomerID
	careWaiverEURcents?: string
}

export type IS_Customer = CS_Customer<IS_CustomerMetadata>
export const IS_castCustomer = CS_castCustomer<IS_CustomerMetadata>

interface IS_PaymentIntentMetadata {
	buy: ProductID | undefined
	customerID: Stripe_CustomerID | undefined
}

export type IS_PaymentIntent = CS_PaymentIntent<IS_PaymentIntentMetadata>
export const IS_castPaymentIntent = CS_castPaymentIntent<IS_PaymentIntentMetadata>

export function IS_isValidPayment(p: Stripe_PaymentIntentWithLatestCharge) {
	// TODO move this somewhere else
	if (p.metadata.amount_refunded) {
		p.latest_charge!.amount_refunded = parseInt(p.metadata.amount_refunded)
		delete p.metadata.amount_refunded
	}
	return p.status === 'succeeded' && p.latest_charge!.amount_refunded === 0
}

interface IS_InvoiceMetadata {
}

export type IS_Invoice = CS_Invoice<IS_InvoiceMetadata>
export const IS_castInvoice = CS_castInvoice<IS_InvoiceMetadata>

interface IS_SubscriptionMetadata {
}

export type IS_Subscription = CS_Subscription<IS_SubscriptionMetadata>
export const IS_castSubscription = CS_castSubscription<IS_SubscriptionMetadata>
